import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import "../../../components/LoadingSpinner/spinner.css";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,
    InputAdornment,
    IconButton,
    
} from "@mui/material";
import { Tooltip } from "antd";
import success from "../../../assets/img/success.png";
import failed from "../../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import { makeStyles } from "@mui/styles";
import { Card, Modal, ModalHeader, Alert } from "reactstrap";
import AddNewUser from "./AddNewUser";
import CustomButton from "../../../../src/components/CustomButton/CustomButton";
import NotificationPopups from "../../../NotificationPopup/NotificationPopups";
import { resetdeleteUserManagement, deleteUserManagement } from "../../../redux/actions/bankUserManagementDeleteAction";
import { resetblockUserManagement, blockUserManagement } from "../../../redux/actions/bankUserManagementBlockAction";
import { resetviewUserDetails, viewUserDetails } from "../../../redux/actions/bankUserManagementViewAction";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

function UserManagementList() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openModal, setopenModal] = useState(false);
    const [custId, setcustId] = useState("");
    const [action, setaction] = useState("");
    const [opendeleteModal, setopendeleteModal] = useState("");

    const classes = useStyles();
    const dispatch = useDispatch();

    const login = useSelector(({ login }) => login);
    const userManagementlist = useSelector(({ bankUserManagementlist }) => bankUserManagementlist);
    const deleteuser = useSelector(({ bankUserManagementDelete }) => bankUserManagementDelete);
    const useraddupdate = useSelector(({ bankUserManagementAddUpdate }) => bankUserManagementAddUpdate);
    const blockuser = useSelector(({ bankUserManagementBlock }) => bankUserManagementBlock);
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const viewEditHandler = (data, value) => {
        setaction(value);
        viewUserHandler(data)
        setopenModal(!openModal);
    }

    const viewUserHandler = (id) => {

        const req = {
            actionCustomerMasterRequestVO: {
                bankId: login.data.partnerId,
                ratId: id,
            }
        }

        if (regenerateTokenRes.success) {
            dispatch(viewUserDetails(req, regenerateTokenRes.data.AuthToken))
        }
    }

    const blockUserHandler = (custId, isAccLocked) => {
        const req = {
            actionCustomerMasterRequestVO: {
                action: isAccLocked === "0" ? "block" : "unblock",
                status: isAccLocked === "0" ? "block" : "unblock",
                isAccountLocked: isAccLocked === "0" ? "0" : "1",
                bankId: login.data.partnerId,
                ratId: custId,
            }
        }

        if (regenerateTokenRes.success) {
            dispatch(blockUserManagement(req, regenerateTokenRes.data.AuthToken))
        }
    }

    const deleteUserHandler = (custid) => {
        setcustId(custid);
        setopendeleteModal(!opendeleteModal);
    }

    const deleteModalHandler = () => {
        setopendeleteModal(!opendeleteModal);
    }

    const deleteUserHandlerFunc = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                bankId: login.data.partnerId,
                ratId: custId,
            }
        }

        if (regenerateTokenRes.success) {
            dispatch(deleteUserManagement(req, regenerateTokenRes.data.AuthToken))
        }
    }

    useEffect(() => {
        if (deleteuser.success) {
            setopendeleteModal(false);
            NotificationPopups(
                "success",
                "Success",
                "User Deleted"
            );
            dispatch(resetdeleteUserManagement());
        }
        if (deleteuser.failed) {
            setopendeleteModal(false);
            NotificationPopups(
                "error",
                "Failed",
                "Something Went Wrong!"
            );
            dispatch(resetdeleteUserManagement());
        }

        if (blockuser.success) {
            NotificationPopups(
                "success",
                "Success",
                blockuser.data.description,
            );
            dispatch(resetblockUserManagement());
        }
        if (blockuser.failed) {
            NotificationPopups(
                "error",
                "Failed",
                "Something Went Wrong!"
            );
            dispatch(resetblockUserManagement());
        }
    }, [deleteuser, blockuser])

    useEffect(() => {
        if (useraddupdate.success) {
            setopenModal(false);
        }
    }, [useraddupdate])

    useEffect(() => {
        return () => {
            dispatch(resetdeleteUserManagement());
            dispatch(resetblockUserManagement());
            dispatch(resetviewUserDetails());
        }
    }, [])

    return (
        <>
            {userManagementlist.isloading ? <LoadingSpinner />
                : userManagementlist.success ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px",
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Report Table
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="text-nowrap my-3">
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow className="themeBackground">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                User ID	{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                User Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Mobile
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Role
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {userManagementlist.success &&
                                            []
                                                .concat(userManagementlist.data.errorList)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">
                                                            {row.customerId}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.ratName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.userName}
                                                        </TableCell>
                                                        <TableCell align="center">{row.mobile}</TableCell>
                                                        <TableCell align="center">{row.role}</TableCell>
                                                        <TableCell align="center">
                                                            <>
                                                                <Tooltip title="View">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => viewEditHandler(row.customerId, "viewUser")}
                                                                    >
                                                                        {
                                                                            <VisibilityIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>

                                                                <Tooltip title="Update">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => viewEditHandler(row.customerId, "updateUser")}
                                                                    >
                                                                        {
                                                                            <EditIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => deleteUserHandler(row.customerId)}
                                                                    >
                                                                        {
                                                                            <DeleteIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                                <Tooltip title={row.isAccLocked === "0" ? "Block" : "Unblock"}>
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        onClick={() => blockUserHandler(row.customerId, row.isAccLocked)}
                                                                    >
                                                                        {
                                                                            <BlockIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                            </>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={[].concat(userManagementlist.data.errorList).length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px",
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 themeBackground"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                )}

            <Dialog open={opendeleteModal} onClose={deleteModalHandler}>
                <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                <DialogActions className="p-3">
                    <CustomButton
                        style={{
                            backgroundColor: "#fff",
                            color: "#000"
                        }}
                        variant="contained"
                        onClick={deleteModalHandler}
                    >
                        Cancel
                    </CustomButton>
                    <CustomButton
                        style={{
                            backgroundColor: "#00b9f5",
                            color: "white"
                        }}
                        variant="contained"
                        onClick={deleteUserHandlerFunc}
                    >
                        Yes
                    </CustomButton>
                </DialogActions>
            </Dialog>

            {openModal && <Modal
                isOpen={openModal}
                toggle={viewEditHandler}
                size="lg"            >
                <ModalHeader toggle={viewEditHandler}>User Details</ModalHeader>
                {/* <ModalBody className="password-modal-body"> */}
                <AddNewUser action={action} />
                {/* </ModalBody> */}
            </Modal>}

        </>
    )
}

export default UserManagementList